<template>
    <component
        :is="TablerIcons[props.name]"
        :size="size"
        :stroke-width="strokeWidth"
        :class="iconClass"
    />
</template>

<script setup>
import * as TablerIcons from '@tabler/icons-vue';

const props = defineProps({
    name: {
        type: String,
        required: true
    },
    size: {
        type: Number,
        default: 24
    },
    strokeWidth: {
        type: Number,
        default: 2
    },
    iconClass: {
        type: String,
        default: ''
    }
});
</script>